module.exports = __webpack_public_path__ + "img/mortar_pin_green.b6563592.svg";